// extracted by mini-css-extract-plugin
export default {"imageContainer":"machine-list-card_imageContainer__Ylscw","image":"machine-list-card_image__Md2x-"};